import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RegisterData, RegisterParams } from '@assetaccountant/core/resolvers/register.resolver';
import {
  TypedActivatedRoute,
  getCurrentRegisterLocale,
} from '@assetaccountant/core/utils/route-utils';
import { getLocaleDateString, toUniversalDateString } from '../utils/date-utils';

@Pipe({
  name: 'aadate',
  standalone: false,
})
export class AaDatePipe extends DatePipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) locale: string,
    @Inject(ActivatedRoute) private route: TypedActivatedRoute<RegisterParams, RegisterData>,
  ) {
    super(locale);
  }

  getFormatForLocale(locale: string): string {
    const formatToUse = getLocaleDateString(locale);
    switch (formatToUse) {
      case 'MDY':
        return 'MMM d yyyy';
      case 'YMD':
        return 'yyyy MMM d';
      // Default is 'DMY'
      default:
        return 'd MMM yyyy';
    }
  }

  transform(value: any, format?: string): any {
    if (format) {
      return super.transform(toUniversalDateString(value), format);
    } else {
      const defaultFormat = this.getFormatForLocale(getCurrentRegisterLocale(this.route.snapshot));
      return super.transform(toUniversalDateString(value), defaultFormat);
    }
  }
}
